import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { Link } from 'core/routing';
import { Sidebar, SidebarItem } from 'apps/home/activityFeed/styles';

export const ProjectSidebar = withNamespaces()(
  observer(({ projects }) => {
    if (projects === null) return null;

    const { contributedProjects } = projects;
    const count = contributedProjects.totalCount;
    if (count === 0) {
      return (
        <Sidebar>
          <SidebarItem title>
            <Trans>Projects you contribute to</Trans>:
          </SidebarItem>
          <SidebarItem last light>
            <Trans>Not contributed to any projects yet...</Trans>
          </SidebarItem>
        </Sidebar>
      );
    }
    const projectsList = [];
    // FIXME - Replace with map
    // eslint-disable-next-line
    for (const [index, p] of contributedProjects.edges.entries()) {
      if (p.node.parentContent) {
        const parentType = p.node.parentContent.type;
        const prefix = parentType === 'profile' ? '@' : '+';
        const routeName =
          parentType === 'profile' ? 'profile.project' : 'initiative.project';
        const routeParams = {
          [routeName.split('.')[0]]: prefix + p.node.parentContent.slug,
          slug: p.node.slug,
        };
        projectsList.push(
          <SidebarItem
            key={p.node.id}
            last={index === contributedProjects.edges.length - 1}
          >
            <Link name={routeName} params={routeParams}>
              {`${prefix}${p.node.parentContent.slug} / ${p.node.slug}`}
            </Link>
          </SidebarItem>,
        );
      }
    }
    return (
      <Sidebar>
        <SidebarItem title>
          <Trans>Projects you contribute to</Trans>:
        </SidebarItem>
        {projectsList}
      </Sidebar>
    );
  }),
);
